export { default } from './FAQCategory'
